import React from 'react';
export default function AlertDisplay(props) {
  const { alerts } = props;

  return (
    <React.Fragment>
      <div className='alert-box'>
        <div className='row'>
          <div className='col-md-6'>
            <div className='alert-box-title'>Urgent Total</div>
            <div className='alert-box-total' style={{ color: '#f73f3f' }}>
              {alerts && alerts.urgent && alerts.urgent.total}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='alert-box-title text-left'>By Type</div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.urgent.type_total.resp_high}
              </span>{' '}
              Resp. High
            </div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.urgent.type_total.resp_low}
              </span>{' '}
              Resp. Low
            </div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.urgent.type_total.bed_exit}
              </span>{' '}
              Bed. Exit
            </div>
          </div>
        </div>
      </div>
      <div className='alert-box'>
        <div className='row'>
          <div className='col-md-6'>
            <div className='alert-box-title'>Warning Total</div>
            <div className='alert-box-total' style={{ color: '#e9a921' }}>
              {alerts && alerts.warning && alerts.warning.total}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='alert-box-title text-left'>By Type</div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.warning.type_total.resp_high}
              </span>{' '}
              Resp. High
            </div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.warning.type_total.resp_low}
              </span>{' '}
              Resp. Low
            </div>
          </div>
        </div>
      </div>
      <div className='alert-box no-border'>
        <div className='row'>
          <div className='col-md-6'>
            <div className='alert-box-title'>General Total</div>
            <div className='alert-box-total' style={{ color: '#22a3bf' }}>
              {alerts && alerts.general && alerts.general.total}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='alert-box-title text-left'>By Type</div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.general.type_total.visit_soon}
              </span>{' '}
              Visit Soon
            </div>
            <div className='alert-box-detail'>
              <span className='alert-total'>
                {alerts && alerts.general.type_total.visit_required}
              </span>{' '}
              Visit Required
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
